module.exports = __webpack_public_path__ + "annualreview2017/static/img/andrew-john-hunter@2x.5a9101f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/board/andrew-john-hunter@2x.jpg
// module id = 254
// module chunks = 0